import { Orcamento } from '@/types/core'
import { VuexModule, Module, Mutation, Action } from 'vuex-module-decorators'
// eslint-disable-next-line
import {
  AgendamentoSolicitacaoItem,
  AgendamentoCirurgia,
  Lembrete,
  StatusAvaliacaoPreAnestesia,
  NovaDataSolicitada,
  Convenio,
  Situacao,
  TipoDocumentoUpload,
  StatusCirurgiaEnum,
  Hospital,
  CentroCirurgico,
  // eslint-disable-next-line
} from '@/types/_'
import Apis from '@/Apis/_'
import _ from 'lodash'
import { getUser } from '@/utils/common'
import ProtocoloApi from '@/Apis/Agendamento/Services/ProtocoloApi'
import { permissionService } from '@/services/permission.service'
import { IProtocolo, IProtocolPendency } from '../../../types/interfaces/protocolo/protocolo.interface'
import { useConvenios, useHospitais } from '@/composables'

@Module({ namespaced: true, name: 'BackofficeFidelizacaoStore' })
export default class BackofficeFidelizacaoStore extends VuexModule {
  private orcamento: Orcamento.IOrcamento = new Orcamento.Orcamento()
  private novaDataSolicitadaDefault: NovaDataSolicitada = {
    dataAgendamento: null,
    dataAgendamentoVirtual: false,
    solicitacaoId: '',
    opcaoDataPrevisto1: '',
    opcaoDataPrevisto2: '',
    opcaoDataPrevisto3: '',
    opcao: 0,
    data: '',
    hora: '',
    alterarData: false,
    numeroAgendamento: '',
  }

  private lembreteDefault: Lembrete = {
    dataLembrete: null,
  }

  public fidelizationStatus: string[] = ['ProtocoloNaoAderente', 'PendenciaDeProtocolo']
  public categoriaDoPlanoParaFidelizacao: string[] = []
  public agrupadorHospital: string[] = []
  public protocolosEspecialidade: string[] = []

  public lembrete: Lembrete = { ...this.lembreteDefault }
  public lembreteStatusFiltro: string = ''
  public deFiltro: Date | string | null = null
  public ateFiltro: Date | string | null = null
  public hospitaisFiltro: string[] = []
  public medicoId: string = ''
  public paciente: string = ''
  public medicosCadastrados: any = []
  public possuiItemParticular: boolean | null = null
  public convenioFiltro: string[] = []
  public preAnestesiaFiltro: string = ''
  public opmeFiltro: string = ''
  public novaDataSolicitadaFiltro: boolean = false
  public dataPrevistaFiltro: boolean = false
  public dataVirtualFiltro: boolean = false
  public origemFiltro: string | null = null
  public statusPrecificacaoOperadoraFiltro: string | null = null
  public numeroAgendamento: string = ''
  public ordenadoPorId: string = 'DataUltimaInteracaoAsc'
  public etapaQuery: string = ''
  public statusAvaliacaoPreAnestesiaQuery: string[] = []
  public data: string[] = []
  public situacoes: string[] = []
  public situacoesCounter: Situacao[] = []
  public cirurgiaRealizada: any = null
  public ordenadoPor: any = [
    { id: 'DataUltimaInteracaoAsc', value: 'Tempo de ação mais antigo' },
    { id: 'DataUltimaInteracaoDesc', value: 'Tempo de ação mais recente' },
  ]

  get hospitais() {
    return useHospitais.hospitaisByCurrentUser
  }

  get convenios() {
    return useConvenios.conveniosByCurrentUser
  }

  public preAnestesiaStatus: any[] = [
    { nome: 'Pendente', status: 'Pendente' },
    { nome: 'Apto', status: 'Apto' },
    { nome: 'Apto com atenção', status: 'AptoComAtencao' },
    { nome: 'Não apto', status: 'NaoApto' },
  ]

  public statusAvaliacaoPreAnestesia: StatusAvaliacaoPreAnestesia[] = []

  public visualizarTriagem: boolean = false
  public novaDataSolicitada: NovaDataSolicitada = { ...this.novaDataSolicitadaDefault }
  public agendamentosCirurgia: AgendamentoCirurgia[] = []
  public caraterFiltro: string | null = null
  public medicoSolicitanteEspecialidade: string[] = []
  public tipoPeriodo: string = 'DataAgendamento'
  public situacoesPendenciaAbertaFiltro: string[] = []
  public filterOn: boolean = false
  public filterDrawer: boolean = false
  public solicitacoes: AgendamentoSolicitacaoItem[] = []

  private paginaDefault: number = 1
  private qtdPorPaginaDefault: number = 25
  public surgerySolicitationProtocols: IProtocolo[] = []

  public pagina: number = this.paginaDefault
  public qtdPorPagina: number = this.qtdPorPaginaDefault
  public totalSolicitacoes: number = 0
  public anexo: any[] = []
  public reservaUti: string[] = []
  public statusRoboAutorizacao: string[] = []
  public mapaCirurgicoStatus: string[] = []
  public tiposAcomodacao: string[] = []
  public sexo: string = ''
  public centrosCirurgico: CentroCirurgico[] = []
  public centroCirurgico: string = ''
  public todosOsStatus: boolean = false
  public todosOsStatusDaArea: boolean = false

  @Mutation
  setTodosOsStatus(value: boolean) {
    if (value && !this.todosOsStatusDaArea) this.situacoes = []
    if (value && this.todosOsStatusDaArea) { this.todosOsStatusDaArea = false; this.situacoes = [] }
    if (!value) this.situacoes = ['analisePreAutorizacao', 'analisePreCotacao']
    this.todosOsStatus = value
  }

  @Mutation
  setTodosOsStatusDaArea(value: boolean) {
    if (value && !this.todosOsStatus) this.situacoes = []
    if (value && this.todosOsStatus) { this.todosOsStatus = false; this.situacoes = [] }
    if (!value) this.situacoes = ['analisePreAutorizacao', 'analisePreCotacao']
    this.todosOsStatusDaArea = value
  }

  @Mutation
  setSurgerySolicitationStatus(value: string) {
    if (this.situacoes.includes(value)) {
      this.situacoes.splice(this.situacoes.indexOf(value), 1)
    } else {
      this.situacoes.push(value)
    }
  }

  @Mutation
  setSurgerySolicitationProtocols(protocols: IProtocolo[]) {
    this.surgerySolicitationProtocols = protocols
  }

  @Mutation
  setCentroCirurgico(value: any) {
    this.centroCirurgico = value
  }

  @Mutation
  setCentrosCirurgico(value: CentroCirurgico[]) {
    this.centrosCirurgico = value
  }

  @Mutation
  clearCentroCirurgico() {
    this.centroCirurgico = ''
  }

  @Mutation
  removeHospitaisFiltro(value: string) {
    const index = this.hospitaisFiltro.indexOf(value)
    if (index >= 0) this.hospitaisFiltro.splice(index, 1)
  }

  @Mutation
  removeReservaUti(value: string) {
    const index = this.reservaUti.indexOf(value)
    if (index >= 0) this.reservaUti.splice(index, 1)
  }

  @Mutation
  removeStatusRoboAutorizacao(value: string) {
    const index = this.statusRoboAutorizacao.indexOf(value)
    if (index >= 0) this.statusRoboAutorizacao.splice(index, 1)
  }

  @Mutation
  removeMapaCirurgicoStatus(value: any) {
    const index = this.mapaCirurgicoStatus.indexOf(value)
    if (index >= 0) this.mapaCirurgicoStatus.splice(index, 1)
  }

  @Mutation
  removeTipoAcomodacao(value: string) {
    const index = this.tiposAcomodacao.indexOf(value)
    if (index >= 0) this.tiposAcomodacao.splice(index, 1)
  }

  @Mutation
  setSexo(value: string) {
    this.sexo = value
  }

  @Mutation
  setReservaUti(value: string[]) {
    this.reservaUti = value
  }

  @Mutation
  setStatusRoboAutorizacao(value: string[]) {
    this.statusRoboAutorizacao = value
  }

  @Mutation
  setmapaCirurgicoStatus(value: string[]) {
    this.mapaCirurgicoStatus = value
  }

  @Mutation
  setTiposAcomodacao(value: string[]) {
    this.tiposAcomodacao = value
  }

  @Mutation
  setAgendamentos(solicitacoes: AgendamentoSolicitacaoItem[]) {
    const slct = solicitacoes.map((e: any) => {
      if (!e.lembreteStatus) e.lembreteStatus = ''
      if (!e.dataAgendamento) e.dataAgendamento = ''

      if (e.statusCirurgia) {
        e.cirurgiaRealizada = e.statusCirurgia === StatusCirurgiaEnum.Realizada
      }

      return e
    })
    this.solicitacoes = slct
  }

  @Mutation
  setCirurgiaRealizada(value: any) {
    this.cirurgiaRealizada = value
  }

  @Mutation
  setOrderBy(orderBy: string) {
    this.ordenadoPorId = orderBy
  }

  @Mutation
  setPaciente(paciente: string) {
    this.paciente = paciente
  }

  @Mutation
  setNovaDataSolicitadaFiltro(value: boolean) {
    this.novaDataSolicitadaFiltro = value
  }

  @Mutation
  setDataPrevistaFiltro(value: boolean) {
    this.dataPrevistaFiltro = value
  }

  @Mutation
  setConvenioFiltro(value: string[]) {
    this.convenioFiltro = value
  }

  @Mutation
  setPreAnestesiaFiltro(value: string) {
    this.preAnestesiaFiltro = value
  }

  @Mutation
  setPossuiItemParticular(value: boolean | null) {
    this.possuiItemParticular = value
  }

  @Mutation
  setStatusPrecificacaoOperadora(value: string | null) {
    this.statusPrecificacaoOperadoraFiltro = value
  }

  @Mutation
  setOpmeFiltro(value: string) {
    this.opmeFiltro = value
  }

  @Mutation
  setDataVirtualFiltro(value: boolean) {
    this.dataVirtualFiltro = value
  }

  @Mutation
  setOrigemFiltro(value: string | null) {
    this.origemFiltro = value
  }

  @Mutation
  setDataAgendamentoVirtual(value: boolean) {
    this.dataVirtualFiltro = value
  }

  @Mutation
  setSalaVirtual(value: boolean) {
    this.novaDataSolicitada.dataAgendamentoVirtual = value
  }

  @Mutation
  setMedicoAssistentes(medicos: any[]) {
    this.medicosCadastrados = medicos
  }

  @Mutation
  setMedicoId(value: string) {
    this.medicoId = value
  }

  @Mutation
  setNumeroAgendamento(value: string) {
    this.numeroAgendamento = value
  }

  @Mutation
  setNumeroReserva(value: string) {
    this.novaDataSolicitada.numeroAgendamento = value
  }

  @Mutation
  setOrdenadoPorId(value: string) {
    this.ordenadoPorId = value
  }

  @Mutation
  setStatusAvaliacaoPreAnestesia(value: StatusAvaliacaoPreAnestesia[]) {
    this.statusAvaliacaoPreAnestesia = value
  }

  @Mutation
  removeConvenioFiltro(value: string) {
    const index = this.convenioFiltro.indexOf(value)
    if (index >= 0) this.convenioFiltro.splice(index, 1)
  }

  @Mutation
  setData(value: string) {
    if (this.data.includes(value)) return
    this.data.push(value)
  }

  @Mutation
  setSituacoes(value: string) {
    if (this.situacoes.includes(value)) {
      this.situacoes.splice(this.situacoes.indexOf(value), 1)
    } else {
      this.situacoes.push(value)
    }
  }

  @Mutation
  clearFidelizationStatuses() {
    this.fidelizationStatus = []
  }

  @Mutation
  addFidelizationStatus(status: string) {
    if (this.fidelizationStatus.includes(status)) {
      this.fidelizationStatus.splice(this.fidelizationStatus.indexOf(status), 1)
    } else {
      this.fidelizationStatus.push(status)
    }
  }

  @Mutation
  setCategoriaDoPlanoParaFidelizacao(value: string[]) {
    this.categoriaDoPlanoParaFidelizacao.splice(0, this.categoriaDoPlanoParaFidelizacao.length)
    if (value) {
      value.forEach(elem => this.categoriaDoPlanoParaFidelizacao.push(elem))
    }
  }

  @Mutation
  setAgrupadorHospitaisIds(value: string[]) {
    this.agrupadorHospital.splice(0, this.agrupadorHospital.length)
    if (value) {
      value.forEach(elem => this.agrupadorHospital.push(elem))
    }
  }

  @Mutation
  setProtocolosEspecialidadeIds(value: string[]) {
    this.protocolosEspecialidade.splice(0, this.protocolosEspecialidade.length)
    if (value) {
      value.forEach(elem => this.protocolosEspecialidade.push(elem))
    }
  }

  @Mutation
  setAllFidelizationStatuses() {
    this.fidelizationStatus = [
      'ProtocoloAderente',
      'ProtocoloNaoAderente',
      'FidelizacaoAceitouJustificativa',
      'PendenciaDeProtocolo',
      'ProtocoloAceito',
      'ProtocoloRecusado',
      'EncaminhadoPelaRegulacao',
      'PendenciaDeProtocoloExpirada',
      'AutorizadaPelaRegulacao',
      'AutorizadaParcialPelaRegulacao',
      'AutorizacaoNegadaPelaRegulacao',
    ]
  }

  @Mutation
  resetSituacoes() {
    this.situacoes = []
  }

  @Mutation
  setSituacoesCounter(value: Situacao[]) {
    this.situacoesCounter = value
  }

  @Mutation
  removeData(value: string) {
    const index = this.data.indexOf(value)
    if (index >= 0) this.data.splice(index, 1)
  }

  @Mutation
  clearAgendamentosCirurgia() {
    this.agendamentosCirurgia = []
  }

  @Mutation
  setFilterOn(value: boolean) {
    this.filterOn = value
  }

  @Mutation
  setPagina(value: number) {
    this.pagina = value
  }

  @Mutation
  setQtdPorPagina(value: number) {
    this.qtdPorPagina = value
  }

  @Mutation
  setTotalSolicitacoes(value: number) {
    this.totalSolicitacoes = value
  }

  @Mutation
  clearPagePagination() {
    this.pagina = this.paginaDefault
    this.qtdPorPagina = this.qtdPorPaginaDefault
  }

  @Mutation
  clearSurgerySolicitations() {
    this.solicitacoes = []
  }

  @Mutation
  deleteSolicitacao(solicitacaoId: string) {
    const index = this.solicitacoes.findIndex(c => c.id === solicitacaoId)
    if (index >= 0) {
      this.solicitacoes.splice(index, 1)
    }
  }

  @Mutation
  clearFiltro() {
    this.ordenadoPorId = 'DataUltimaInteracaoAsc'
    this.paciente = ''
    this.medicoId = ''
    this.numeroAgendamento = ''
    this.novaDataSolicitadaFiltro = false
    this.dataPrevistaFiltro = false
    this.novaDataSolicitada = { ...this.novaDataSolicitadaDefault }
    this.dataVirtualFiltro = false
    this.origemFiltro = null
    this.caraterFiltro = null
    this.statusPrecificacaoOperadoraFiltro = null
    this.possuiItemParticular = null
    this.convenioFiltro = []
    this.hospitaisFiltro = []
    this.preAnestesiaFiltro = ''
    this.opmeFiltro = ''
    this.lembreteStatusFiltro = ''
    this.deFiltro = null
    this.ateFiltro = null
    this.statusAvaliacaoPreAnestesiaQuery = []
    this.cirurgiaRealizada = null
    this.medicoSolicitanteEspecialidade = []
    this.data = []
    this.statusRoboAutorizacao = []
    this.centroCirurgico = ''
    this.tipoPeriodo = 'DataAgendamento'
    this.situacoesPendenciaAbertaFiltro = []
  }

  @Mutation
  setLembreteStatus(params: any) {
    const solicitacao = this.solicitacoes.find((e: any) => e.id === params.solicitacaoId)
    const solicitacaoIndex = this.solicitacoes.findIndex((e: any) => e.id === params.solicitacaoId)
    // @ts-ignore
    solicitacao.lembreteStatus = params.concluido ? '' : 'Normal'
    // @ts-ignore
    this.solicitacoes[solicitacaoIndex] = solicitacao
  }

  @Mutation
  setLembreteStatusFiltro(value: string) {
    this.lembreteStatusFiltro = value
  }

  @Mutation
  setEtapa(etapa: string) {
    this.etapaQuery = etapa
  }

  @Mutation
  setAnexo(anexo: any) {
    if (!this.anexo) {
      this.anexo = []
    }
    this.anexo.push(anexo)
  }

  @Mutation
  setAnexos(anexo: any[]) {
    this.anexo = anexo
  }

  @Mutation
  setTipoPeriodo(value: string) {
    this.tipoPeriodo = value
  }

  @Mutation
  setHospitaisFiltro(value: string[]) {
    this.hospitaisFiltro = value
  }

  @Mutation
  setDeFiltro(value: Date | string | null) {
    this.deFiltro = value
  }

  @Mutation
  setAteFiltro(value: Date | string | null) {
    this.ateFiltro = value
  }

  @Mutation
  setSituacoesPendenciaAbertaFiltro(value: string[]) {
    this.situacoesPendenciaAbertaFiltro = value
  }

  @Mutation
  setCaraterFiltro(value: string | null) {
    this.caraterFiltro = value
  }

  @Mutation
  removeSituacoesPendenciaAbertaFiltro(value: string) {
    const index = this.situacoesPendenciaAbertaFiltro.indexOf(value)
    if (index >= 0) this.situacoesPendenciaAbertaFiltro.splice(index, 1)
  }

  @Mutation
  clearSituacoes() {
    this.situacoes = []
  }

  @Action
  async getSurgerySolicitationProtocol({ hospitalId, protocolId }): Promise<IProtocolo | { kitsDeOpme: any, tecnicasDeCirurgia: any }> {
    if (hospitalId && protocolId) {
      const surgeryProtocolAPIResponse = await ProtocoloApi.getProtocoloById({ hospitalId, protocoloId: protocolId })
      return surgeryProtocolAPIResponse.data || { kitsDeOpme: [], tecnicasDeCirurgia: [] }
    }

    return { kitsDeOpme: [], tecnicasDeCirurgia: [] }
  }

  @Action
  async blockFidelizationSurgerySolicitation(surgerySolicitationId: string): Promise<any> {
    const APIResponse = await ProtocoloApi.blockFidelizationSurgerySolicitation(surgerySolicitationId)
    return APIResponse
  }

  @Action
  async unblockFidelizationSurgerySolicitation(surgerySolicitationId: string): Promise<any> {
    const APIResponse = await ProtocoloApi.unblockFidelizationSurgerySolicitation(surgerySolicitationId)
    return APIResponse
  }

  @Action
  async openProtocolPendency({
    surgerySolicitationId,
    protocolId,
    surgeryTechniqueId,
    reasonSelectedKit,
    surgeryMaterialKitId,
  }: {
    surgerySolicitationId: string,
    protocolId?: string,
    reasonSelectedKit: string,
    surgeryMaterialKitId?: string,
    surgeryTechniqueId?: string,
  }): Promise<any> {
    const parsedBody: IProtocolPendency = {
      observacaoDaPendenciaDeProtocolo: reasonSelectedKit,
    }

    if (protocolId) {
      parsedBody.protocoloId = protocolId
    }

    if (surgeryMaterialKitId) {
      parsedBody.kitId = surgeryMaterialKitId
    }

    if (surgeryTechniqueId) {
      parsedBody.tecnicaId = surgeryTechniqueId
    }

    const APIResponse = await ProtocoloApi.openProtocolPendency(surgerySolicitationId, parsedBody)
    return APIResponse
  }

  @Action
  async acceptDoctorJustification({
    surgerySolicitationId,
    reason,
  }): Promise<any> {
    const APIResponse = await ProtocoloApi.acceptDoctorJustification(surgerySolicitationId, reason)
    return APIResponse
  }

  @Action({ commit: 'setSurgerySolicitationProtocols' })
  async getAllSurgerySolicitationProtocols(surgerySolicitation) {
    const { hospitalId, medicoSolicitanteId: doctorId, procedimento: procedure, paciente: patient } = surgerySolicitation
    const { convenioId: healthInsuranceId, planoId: planId } = patient
    const { codigo: procedureCode } = procedure

    if (
      hospitalId && doctorId
      && procedure && procedureCode
      && patient && healthInsuranceId
    ) {
      const surgeryProtocolsAPIResponse = await ProtocoloApi.getProtocolosByCirurgia({
        hospitalId,
        medicoId: doctorId,
        codigoDoProcedimentoPrincipal: procedureCode,
        convenioId: healthInsuranceId,
        planoId: planId,
      })

      return surgeryProtocolsAPIResponse.data || []
    }

    return []
  }

  @Mutation
  setFilterDrawer(value: boolean) {
    this.filterDrawer = value
  }

  @Action
  async loadAgendamentosMedicoSearch() {
    const param = {
      usuarioId: getUser().profile.sub,
      etapa: 'fidelizacao',
      statusFidelizacao: this.fidelizationStatus,
      situacao: this.situacoes,
      categoriaDoPlanoParaFidelizacao: this.canShowFilterByProtocoloProductLine ? this.categoriaDoPlanoParaFidelizacao : undefined,
      agrupadorHospital: this.agrupadorHospital,
      protocolosEspecialidade: this.protocolosEspecialidade,
      orderBy: 'DataDoEnvioDesc',
      pagina: this.pagina,
      possuiItemParticular: this.possuiItemParticular,
      qtdPorPagina: this.qtdPorPagina,
      hospitalId: this.hospitaisFiltro,
      carater: this.caraterFiltro,
      paciente: this.paciente,
      medicoId: this.medicoId,
    }

    const response = await Apis.Agendamento.AgendamentoMedicoBackofficeApi.getAllSearch(param)

    if (response.success) {
      this.context.commit('setAgendamentos', response.data.solicitacoes)
      this.context.commit('setSituacoesCounter', response.data.situacoes)
      this.context.commit('setTotalSolicitacoes', response.data.totalSolicitacoes)
      this.context.commit('setStatusAvaliacaoPreAnestesia', response.data.statusAvaliacaoPreAnestesia)
    }

    return response
  }

  get canShowFilterByProtocoloProductLine() {
    return permissionService.hasPermission('agendamento.backoffice.protocolo.visualizarProductLine')
  }

  @Action
  async getAllConvenios() {
    await useConvenios.loadConveniosByCurrentUser()
  }

  @Action
  async deleteLaudo(params: any) {
    const request = await this.orcamento.deleteLaudo(params.hospitalId, params.id)

    return request
  }

  @Action
  async uploadAnexos(params: any) {
    const response = await this.orcamento.upload(params.form, TipoDocumentoUpload.OrcamentoDeCirurgiaParticular, params.header, params.solicitacaoId)
    return response
  }

  @Action
  async getAllLaudos(solicitacaoId: string) {
    const response = await this.orcamento.getAllLaudos(solicitacaoId, TipoDocumentoUpload.OrcamentoDeCirurgiaParticular)
    if (response.success) {
      this.context.commit('setAnexos', response.data)
    }
    return response
  }

  @Action
  async backofficeOrcamentoEnviaOrcamento(params: any) {
    const response = await this.orcamento.backofficeOrcamentoEnviaOrcamento(params)
    return response
  }

  @Action
  async getAllHospitais() {
    await useHospitais.loadHospitaisByCurrentUser()
  }


  @Action
  async getCentroCirurgicoByHospitalId(params: any) {
    const { hospitalIds } = params
    if (hospitalIds && hospitalIds.length <= 0) {
      this.context.commit('setCentrosCirurgico', [])
      this.context.commit('clearCentroCirurgico')
      return null
    }

    const request = await this.orcamento.getCentroCirurgico(params)
    if (request.success) {
      request.data.map((c) => {
        const temp = c
        temp.nome = `${c.hospital.nome} - ${c.nome}`
        return temp
      })

      this.context.commit('setCentrosCirurgico', request.data)
    }
    return request
  }

  @Action
  init() {
    this.context.dispatch('getAllHospitais')
    this.context.dispatch('getAllConvenios')
  }
}
